import { render, staticRenderFns } from "./card-progress.vue?vue&type=template&id=8136c9ea&scoped=true&"
import script from "./card-progress.vue?vue&type=script&lang=js&"
export * from "./card-progress.vue?vue&type=script&lang=js&"
import style0 from "./card-progress.vue?vue&type=style&index=0&id=8136c9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8136c9ea",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText, CImage: require('@chakra-ui/vue').CImage, CLink: require('@chakra-ui/vue').CLink, CFlex: require('@chakra-ui/vue').CFlex})
